import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Chip from '@material-ui/core/Chip';
import AddCouponDrawer from './AddCouponDrawer';
import translations from './translations';
import Grid from '@material-ui/core/Grid';

const CouponsFormSection = ({ coupons, onAddCoupon, onRemoveCoupon }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [showAddCoupon, setShowAddCoupon] = useState(false);

  const handleAddCoupon = async ({ coupon }) => {
    try {
      if (onAddCoupon && typeof onAddCoupon === 'function') {
        await onAddCoupon(coupon);
      }

      enqueueSnackbar(intl.formatMessage(translations.feedback.couponAdded), {
        variant: 'success',
      });

      setShowAddCoupon(false);
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.couponNotAdded), {
        variant: 'error',
      });
    }
  };

  const handleRemoveCoupon = async coupon => {
    try {
      if (onRemoveCoupon && typeof onRemoveCoupon === 'function') {
        await onRemoveCoupon(coupon);
      }

      enqueueSnackbar(intl.formatMessage(translations.feedback.couponRemoved), {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.couponNotRemoved), {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <Card style={{ marginBottom: 8 }}>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
          action={
            <Button color="primary" variant="outlined" onClick={() => setShowAddCoupon(true)}>
              <FormattedMessage {...translations.button.add.label} />
            </Button>
          }
        />
        <CardContent>
          <Grid container spacing={1}>
            {coupons.map(coupon => (
              <Grid item>
                <Chip key={coupon} label={coupon} onDelete={() => handleRemoveCoupon(coupon)} />
              </Grid>
            ))}
          </Grid>
          {coupons?.length === 0 && <FormattedMessage {...translations.emptyMessage} />}
        </CardContent>
      </Card>
      <AddCouponDrawer
        isOpen={showAddCoupon}
        onClose={() => setShowAddCoupon(false)}
        onSubmit={handleAddCoupon}
      />
    </>
  );
};

CouponsFormSection.propTypes = {
  coupons: PropTypes.array,
  onAddCoupon: PropTypes.func,
  onRemoveCoupon: PropTypes.func,
};

CouponsFormSection.defaultProps = {
  coupons: [],
  onAddCoupon: undefined,
  onRemoveCoupon: undefined,
};

export default CouponsFormSection;
